// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

export function PriceWarning(): React.MixedElement {
  const { __ } = useTranslator();
  return (
    <Base marginBottom="base">
      <Base padding="small" backgroundColor="white">
        <Base tagName="p" margin="none">
          {__(
            'Prices, promos, and product options depend on your rate scale, ' +
              'applicable offers, and associated product services. ' +
              'They may therefore change once you have logged into your account.',
          )}
        </Base>
      </Base>
    </Base>
  );
}
